import { useCurrencyRates } from '@/hooks/api/useCurrency'
import { getDisplayPrice } from '@/utils/convertPrice'
import { useUserPreferences } from '@/stores/userPreferences'

/**
 * Hook to get the display price for a product based on user's preferred currency
 * Works for both authenticated and unauthenticated users by reading from local store
 * @param originalPrice The original product price
 * @param originalCurrency The product's currency
 * @returns Object with displayPrice, displayCurrency, and loading state
 */
export function useDisplayPrice(
    originalPrice: number,
    originalCurrency: string
) {
    const { preferredCurrency } = useUserPreferences()
    const { data: rates, isLoading: ratesLoading } = useCurrencyRates()

    const isLoading = ratesLoading

    const { displayPrice, displayCurrency } = getDisplayPrice(
        originalPrice,
        originalCurrency,
        preferredCurrency || undefined,
        rates?.rates
    )

    return {
        displayPrice,
        displayCurrency,
        isLoading,
    }
}
